import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { QuotationRequestResponse } from '@/api/bol';

export interface QuotationRequestDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  quotationRequest: QuotationRequestResponse | null;
}

export const QuotationRequestDeleteDialog: React.FC<QuotationRequestDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  quotationRequest
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="quotation request"
      itemId={quotationRequest?.id || ''}
    />
  );
};